export default __webpack_public_path__ + "61b956851196e664086f51d860f00d80.svg";